import React, { useMemo } from 'react'
import SelectDropdown from '../../components/SelectDropdown'
import ButtonCommon from '../../components/Button'
import useCategories from '../hooks/useCategories'

export const SORT_OPTIONS = [
  { value: 'PRICE_ASC', label: 'Sort by price (Asc)' },
  { value: 'PRICE_DESC', label: 'Sort by price (Desc)' },
  { value: 'TOTAL_PURCHASE_ASC', label: 'Sort by Total purchase (Asc)' },
  { value: 'TOTAL_PURCHASE_DESC', label: 'Sort by Total purchase (Desc)' },
  { value: 'STOCK_ASC', label: 'Sort by stock (Asc)' },
  { value: 'STOCK_DESC', label: 'Sort by stock (Desc)' },
]

export const EVENT_STATUS_OPTIONS = [
  { value: '0', label: 'Closed' },
  { value: '1', label: 'Open' },
]

function ProductFilter({
  events,
  eventFilter,
  statusFilter,
  sortFilter,
  categoryFilter,
  onChangeEvent,
  onChangeEventStatus,
  onChangeSort,
  onChangeCategory,
  handleClearFilter,
}) {
  const { categoryOptions } = useCategories()

  const eventOptions = useMemo(
    () =>
      events?.map((event, index) => ({
        value: index,
        label: event.title,
        id: event.id,
      })) || [],
    [events]
  )

  return (
    <div className='d-flex align-items-center mt-3 flex-wrap gap-2'>
      <div style={{ marginBottom: '10px' }}>
        <SelectDropdown
          isMulti
          isClearable
          value={eventFilter}
          onChange={onChangeEvent}
          options={eventOptions}
          placeholder='All Events'
          minWidth='300px'
        />
      </div>

      <div style={{ marginBottom: '10px' }}>
        <SelectDropdown
          isClearable
          isMulti
          closeMenuOnSelect={false}
          value={statusFilter}
          onChange={onChangeEventStatus}
          options={EVENT_STATUS_OPTIONS}
          placeholder='All Status'
          minWidth='150px'
        />
      </div>

      <div style={{ marginBottom: '10px' }}>
        <SelectDropdown
          isClearable
          value={sortFilter}
          onChange={onChangeSort}
          options={SORT_OPTIONS}
          placeholder='All Sort'
          minWidth='180px'
        />
      </div>

      <div style={{ marginBottom: '10px' }}>
        <SelectDropdown
          isMulti
          isClearable
          value={categoryFilter}
          onChange={onChangeCategory}
          options={categoryOptions}
          placeholder='All Categories'
          minWidth='180px'
        />
      </div>

      <div style={{ marginBottom: '10px' }}>
        <ButtonCommon
          variant='outline-danger'
          content='Clear Filter'
          onClick={handleClearFilter}
        />
      </div>
    </div>
  )
}

export default ProductFilter
